import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface Props {
    count?: number;
}

const AccountSkeleton: React.FC<Props> = ({ count = 3 }) => (
    <>
        {Array.from(Array(count)).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="sgw-link-panel skeleton-link-panel" key={`skeleton-account-${index}`}>
                <Skeleton height={20} />
                <Skeleton width="30%" />
            </div>
        ))}
    </>
);

export default AccountSkeleton;
